const normalizeText = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();
const normalizeDigits = (value) => normalizeText(value).replace(/\D/g, "");
const normalizeYear = (value) => (value ? normalizeText(value) : "");

export const COLUMNS = [
  { label: "Login Email", field: "username" },
  { label: "First Name", field: "firstName" },
  { label: "Last Name", field: "lastName" },
  { label: "Position", field: "primaryPosition" },
  { label: "State", field: "state" },
  { label: "Athlete Email", field: "athleteEmail" },
  { label: "Athlete Phone", field: "athletePhone", normalize: normalizeDigits },
  { label: "Parent Email", field: "parentEmail" },
  { label: "Parent Phone", field: "parentPhone", normalize: normalizeDigits },
  {
    label: "Grad Year",
    field: "expectedYearOfGraduation",
    normalize: normalizeYear,
  },
];

export const getMatchingFields = (members = []) =>
  COLUMNS.reduce((matches, col) => {
    const normalize = col.normalize ?? normalizeText;
    const values = members.map((m) => normalize(m[col.field])).filter(Boolean);
    matches[col.field] = values.every((v) => v === values[0]);
    return matches;
  }, {});

export const cellColor = (isMatch) =>
  isMatch ? "bg-green-50 border-green-200" : "bg-red-50 border-red-200";

export const toPair = (userIdA, userIdB) => ({
  primaryId: Math.max(userIdA, userIdB),
  secondaryId: Math.min(userIdA, userIdB),
});

export const isPairDismissed = (group, userIdA, userIdB) => {
  const { primaryId, secondaryId } = toPair(userIdA, userIdB);
  return Boolean(
    group.dismissedPairs?.some(
      (p) => p.higherUserId === primaryId && p.lowerUserId === secondaryId,
    ),
  );
};

export const groupKeyOf = (group) =>
  (group.members ?? []).map((m) => m.userId).join("-");

export const hasPendingPairs = (group) => {
  const n = group.members?.length ?? 0;
  return (group.dismissedPairs?.length ?? 0) < (n * (n - 1)) / 2;
};

export const memberName = (group, userId) => {
  const member = (group.members ?? []).find((m) => m.userId === userId);
  return member ? `${member.firstName} ${member.lastName}` : `#${userId}`;
};

export const withPairDismissed = (
  groups,
  groupKey,
  { primaryId, secondaryId },
  keepFullyDismissed,
) =>
  groups
    .map((group) =>
      groupKeyOf(group) !== groupKey
        ? group
        : {
            ...group,
            dismissedPairs: [
              ...(group.dismissedPairs ?? []),
              { lowerUserId: secondaryId, higherUserId: primaryId },
            ],
          },
    )
    .filter((group) => keepFullyDismissed || hasPendingPairs(group));

export const withPairRestored = (
  groups,
  groupKey,
  { primaryId, secondaryId },
) =>
  groups.map((group) =>
    groupKeyOf(group) !== groupKey
      ? group
      : {
          ...group,
          dismissedPairs: (group.dismissedPairs ?? []).filter(
            (p) =>
              !(p.higherUserId === primaryId && p.lowerUserId === secondaryId),
          ),
        },
  );

export const displayValue = (member, field) => member[field] || "—";
